import Yup from './validate'

export const ContactSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    subject: Yup.string().required("Required"),
    email: Yup.string().email("Invalid email").required("Required"),
    message: Yup.string().min(10, "Minimum 10 characters").required("Required"),
    turnstile: Yup.string().required("Please verify that you are not a robot."),
    agreement: Yup.boolean()
        .oneOf([true], "You must give your approval to continue..")
        .required("You must give your approval to continue.."),
});